import { Navigate } from "react-router-dom";

/**
 * Redirects "/" to "/fr" or "/en" based on stored preference or browser language.
 */
export const RootRedirect = () => {
  const getPreferredLang = (): "fr" | "en" => {
    try {
      const stored = localStorage.getItem("preferred-language");
      if (stored === "fr" || stored === "en") return stored;
    } catch {}
    const browserLang = navigator.language || "";
    return browserLang.toLowerCase().startsWith("en") ? "en" : "fr";
  };

  return <Navigate to={`/${getPreferredLang()}`} replace />;
};
